import defaultSettings from "./defaultSettings";
import { gatewayConfig } from "./gateway";
import { privateRoutes } from "./routes";

const { REACT_APP_ENV } = process.env;

const {
  GEO_SERVICE,
  USER_SERVICE,
  SYSTEMS_SERVICE,
  DETECTION_SERVICE,
  MAIL_SERVICE,
  NEGOTIATION_SERVICE,
  CAMPAIGN_SERVICE,
  PLANNING_SERVICE,
  SHARE_SERVICE,
  TOKEN_SERVICE,
  ORDER_SERVICE,
  ADVERTISER_SERVICE,
  SCHEDULER_SERVICE,
  HISTORY_SERVICE,
  CDN_SERVICE,
  QUOTE_SERVICE,
  OTP_SERVICE,
  LICENSES_SERVICE,
  SEARCH_SERVICE,
} = gatewayConfig;

if (REACT_APP_ENV) {
  console.log("REACT_APP_ENV", REACT_APP_ENV);
}

const themes = {
  classic: {
    primaryColor: "#3E00FB",
    successColor: "#0A8A15",
    infoColor: "#0A7F8A",
    processingColor: "#BFBFBF",
    warningColor: "#FFC53D",
    token: {
      colorPrimaryBg: "#F9F5FF",
      colorPrimaryBgHover: "#C6A3FF",
      colorPrimaryBorder: "#A97AFF",
      colorPrimaryBorderHover: "#8952FF",
      colorPrimaryHover: "#6529FF",
      colorPrimary: "#3E00FB",
      colorPrimaryActive: "#2E00D4",
      colorPrimaryTextHover: "#6529FF",
      colorPrimaryText: "#3E00FB",
      colorPrimaryTextActive: "#2E00D4",
      colorTextBase: "#000000",
      colorBgBase: "#FFFFFF",
    },
  },
  /*
  dark: {
    token: {
      colorPrimaryBg: "#F9F5FF",
      colorPrimaryBgHover: "#C6A3FF",
      colorPrimaryBorder: "#A97AFF",
      colorPrimaryBorderHover: "#8952FF",
      colorPrimaryHover: "#6529FF",
      colorPrimary: "#3E00FB",
      colorPrimaryActive: "#2E00D4",
      colorPrimaryTextHover: "#6529FF",
      colorPrimaryText: "#3E00FB",
      colorPrimaryTextActive: "#2E00D4",
      colorTextBase: "#FFFFFF",
      colorBgBase: "#000000",
      colorBgContainer: "#181515",
      colorBgElevated: "#181515",
      bodyBg: "181515",
      contentBg: "#000000",
      colorText: "#FFFFFF",
    },
  },
  */
};

const theme = themes.classic;

export const defineConfig = {
  ...defaultSettings,
  theme: {...theme},
  sidebar: false,
  footer: false,
  routes: privateRoutes,
  GOOGLE_MAPS_API_KEY: "AIzaSyAFkwneQjAMG1ozsc80YaQYZzyfhdsKmyI",
  GOOGLE_MAPS_SYSTEM_MAP_ID: "cbeb47120e7c09a1",
  GOOGLE_MAPS_ADVANCED_MARKER_COMPONENT: false,
  DETECTION_SERVICE: DETECTION_SERVICE(REACT_APP_ENV || "prod"),
  MAIL_SERVICE: MAIL_SERVICE(REACT_APP_ENV || "prod"),
  GEO_SERVICE: GEO_SERVICE(REACT_APP_ENV || "prod"),
  USER_SERVICE: USER_SERVICE(REACT_APP_ENV || "prod"),
  SYSTEMS_SERVICE: SYSTEMS_SERVICE(REACT_APP_ENV || "prod"),
  CAMPAIGN_SERVICE: CAMPAIGN_SERVICE(REACT_APP_ENV || "prod"),
  PLANNING_SERVICE: PLANNING_SERVICE(REACT_APP_ENV || "prod"),
  NEGOTIATION_SERVICE: NEGOTIATION_SERVICE(REACT_APP_ENV || "prod"),
  ADVERTISER_SERVICE: ADVERTISER_SERVICE(REACT_APP_ENV || 'prod'),
  SHARE_SERVICE: SHARE_SERVICE(REACT_APP_ENV || 'prod'),
  TOKEN_SERVICE: TOKEN_SERVICE(REACT_APP_ENV || 'prod'),
  ORDER_SERVICE: ORDER_SERVICE(REACT_APP_ENV || 'prod'),
  SCHEDULER_SERVICE: SCHEDULER_SERVICE(REACT_APP_ENV || 'prod'),
  HISTORY_SERVICE: HISTORY_SERVICE(REACT_APP_ENV || 'prod'),
  CDN_SERVICE: CDN_SERVICE(REACT_APP_ENV || 'prod'),
  QUOTE_SERVICE: QUOTE_SERVICE(REACT_APP_ENV || 'prod'),
  OTP_SERVICE: OTP_SERVICE(REACT_APP_ENV || 'prod'),
  LICENSES_SERVICE: LICENSES_SERVICE(REACT_APP_ENV || 'prod'),
  SEARCH_SERVICE: SEARCH_SERVICE(REACT_APP_ENV || 'prod'),

};
